<template>
  <v-container id="dashboard" fluid tag="section">
    <div>
      <Memorial v-if="seting_sys.seting_sys_grayscale === '1' || seting_sys.seting_sys_grayscale === 1"/>
    </div>
    <div>
      <welcome v-if="!isLoggedIn" />
    </div>

    <template>
      <ScheduleDashboard />

      <v-container fluid class="section-divider pa-4 pa-md-6 pb-0">
        <v-card flat class="section-divider-card">
          <v-card-text class="d-flex align-center pa-4">
            <div class="section-divider-icon mr-3">
              <v-icon size="24" color="white">mdi-chart-box-outline</v-icon>
            </div>
            <div>
              <div class="section-divider-title">บริการข้อมูล</div>
              <div class="section-divider-subtitle grey--text text--darken-1">
                สถิตินักเรียน นักศึกษา และบุคลากร พร้อมส่งออกข้อมูลเป็น Excel
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>

      <v-row>
        <!-- Component Zone -->
        <v-col cols="12" md="12">
          <ReportPerson />
        </v-col>


        <v-col cols="12">
          <personnel_etcSummary />
        </v-col>

        <v-col cols="12">
          <Personnel_etcSummaryBranchsub />
        </v-col>


         <v-col cols="12" md="12">
          <Personnel_etcSummarySubject />
        </v-col>


        <v-col cols="12" md="12">
          <stdsummary />
        </v-col>

        <v-col cols="12" md="12">
          <ReportCollege />
        </v-col>
        <v-col cols="12" md="12">
          <HrApppoint />
        </v-col>
        <v-col cols="12" md="12">
          <ReportBranch />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { Bar } from "vue-chartjs";
import FlipCountdown from "vue2-flip-countdown";
import ScheduleDashboard from "./components/core/ScheduleDashboard.vue";

import personnel_etcSummary from "./component/personnel_etcSummary";
import stdsummary from "./component/stdsummary.vue";
import HrApppoint from "./components/core/hrApppoint.vue";
import ReportPerson from "./components/core/reportPerson.vue";
import ReportCollege from "./components/core/reportCollege.vue";
import ReportBranch from "./components/core/reportBranch.vue";
import Personnel_etcSummarySubject from "./component/personnel_etcSummarySubject.vue";
import Personnel_etcSummaryBranchsub from "./component/personnel_etcSummaryBranchsub.vue";
import welcome from "./components/core/welcome.vue";
import Memorial from "./components/memorial.vue";
export default {
  name: "DashboardDashboard",
  extends: Bar,
  components: {
    Memorial,
    FlipCountdown,
    personnel_etcSummary,
    stdsummary,
    ScheduleDashboard,
    HrApppoint,
    ReportPerson,
    ReportCollege,
    ReportBranch,
    Personnel_etcSummarySubject,
    Personnel_etcSummaryBranchsub,
    welcome
  },
  data() {
    return {
      loading: false,
      seting_sys: []

    };
  },
  async mounted() {
    await this.seting_sysQuery();

  },

  methods: {
     async seting_sysQuery() {
      let result = await this.$http.post("seting_sys.php", {
        ApiKey: "HRvec2021",
        seting_sys_id: "1"
      });
      this.seting_sys = result.data;     
    }
  },
  computed: {
    color() {
      return "blue lighten-4";
    },
    isLoggedIn() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        return !!(user && user.session_token);
      } catch (e) {
        return false;
      }
    }
  }
};
</script>
<style scoped>

#btnnavi {
  width: 50%;
}
.texth2 {
  font-size: xx-large;
  color: yellow;
}

.section-divider {
  max-width: none;
}

.section-divider-card {
  border-radius: 14px !important;
  border: 1px solid #e4e4e7 !important;
  background: #ffffff !important;
}

.section-divider-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #263238, #455a64);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-divider-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #263238;
  line-height: 1.3;
}

.section-divider-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}
</style>

<style>
/* หน้าแรก: ทุกส่วน (ต้อนรับ / ปฏิทิน / สถิติ) ใช้ความกว้างสูงสุดและขอบข้างเดียวกัน
   เดิมแต่ละส่วนกำหนดกว้างเอง (1200px / เต็มจอ) ทำให้ขอบซ้าย-ขวาเหลื่อมกัน */
#dashboard {
  max-width: 1320px;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 24px 48px;
}
#dashboard .schedule-dashboard {
  max-width: none;
}
/* คอนเทนเนอร์ซ้อนกันของแต่ละส่วนมี padding ข้างต่างกัน (12/16/24px) ทำให้ขอบเหลื่อม → ตัดออก ให้ #dashboard คุมขอบเดียว */
html body #dashboard .container.container--fluid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
/* คอนเทนเนอร์ของการ์ดแจ้งเตือนที่ซ้อนกันและว่างเปล่าสะสม padding แนวตั้งจนเกิดช่องว่างใหญ่ */
html body #dashboard .schedule-tab-items .container.container--fluid {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
/* ส่วนสรุปที่ฝังในหน้าแรกเดิมเป็นแผงสีเทาสูงเต็มจอ (100vh) ทุกส่วน → ยุบให้เป็นพื้นขาวสูงตามเนื้อหา */
html body #dashboard .personnel-report-wrapper,
html body #dashboard .dashboard-container,
html body #dashboard .student-dashboard {
  min-height: 0 !important;
  background: transparent !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
html body #dashboard .schedule-dashboard,
html body #dashboard .section-divider {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
